import { useParams } from "react-router-dom";
import LmcPrivateRoute from "./components/LmcPrivateRoute";
import LoadingPage from "../../public/LoadingPage";
import UnknownProcessTypeView from "../error/UnknownProcessTypeView";
import { useGetProcessData } from "../../../hooks/entity";
import { useLmcUserView } from "../../../contexts/AuthContext";
import LoyaltyDashboardRenderer from "../../organisms/LoyaltyDashboardRenderer";

const LoyaltyProgramDashboardApp = () => {
  const { processId } = useParams();
  const { dispatch } = useLmcUserView();

  const { isLoading, isError, isSuccess } = useGetProcessData(
    processId as string,
    {
      onSuccess: (data) => {
        dispatch({
          type: "ENTITY",
          payload: data,
        });
      },
    }
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isError) {
    return <UnknownProcessTypeView processType={undefined} />;
  }

  if (!isSuccess) {
    return null;
  }

  return (
    <LmcPrivateRoute>
      <LoyaltyDashboardRenderer />
    </LmcPrivateRoute>
  );
};

export default LoyaltyProgramDashboardApp;
